import { ToastContainer } from '@pepsico-ds/ui'
import React, { useEffect } from 'react'
import { useAppDispatch } from 'store'
import { resetToastNotifications } from 'store/slices/commonSlice'

function Alert({ data }) {
  const dispatch = useAppDispatch()
  const onCloseClick = () => {
    dispatch(resetToastNotifications())
  }
  useEffect(() => {
    const itv = setTimeout(() => onCloseClick(), 5000)
    return () => clearTimeout(itv)
  }, [])
  return (
    <ToastContainer
      data={[{ id: 1, text: data?.message, type: data.type }]}
      position="top-right"
      showActionIcon
      removeToast={() => onCloseClick()}
    />
  )
}

export default Alert
